import { render, staticRenderFns } from "./action-menu.popover.vue?vue&type=template&id=3d0bff2a&scoped=true"
import script from "./action-menu.popover.vue?vue&type=script&lang=js"
export * from "./action-menu.popover.vue?vue&type=script&lang=js"
import style0 from "./action-menu.popover.vue?vue&type=style&index=0&id=3d0bff2a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0bff2a",
  null
  
)

export default component.exports